module.exports = __webpack_public_path__ + "img/cover.ef6bcc13.jpg";